<template>
    <div>
        <template v-if="!viewDPRDaily">
            <PermissionDenied />
        </template>
        <template v-else>
            <vs-row>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
                    <SelectDate class="w-full my-3 mb-3" :selectedDate.sync="date" label="Date" />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
                    <InputSelect
                        :model.sync="report_"
                        placeholder="Select Report"
                        container_class="w-full my-3 mb-3"
                        :options="report_options"
                        label="Report"
                    />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
                    <InputSelect 
                        :model.sync="package_"
                        placeholder="Select Package"
                        container_class="w-full my-3 mb-3"
                        :options="package_options"
                        label="Package"
                        :disabled="!report_"
                    />
                </vs-col>
                <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
                    <SelectForeign
                        label="SAP PO"
                        :model.sync="dpr_log_po_data.sap_po"
                        placeholder="Type to Search.."
                        :multiple="false"
                        :load_initial="true"
                        :label_keys="['po_number', ]"
                        :show_id_in_label="false"
                        :endpoint="`${$store.state.apiendpoints.sap_po_list}?status=a`"
                        container_class="w-full"
                        input_class=""
                        :use_id_as_value="false"
                        :disabled="Boolean(dpr_log_po_data && dpr_log_po_data.is_associated) || !(createDPRDaily || editDPRDaily)"
                        :autoselect_first="true"
                    />
                </vs-col>
            </vs-row>
    
            <template v-if="loading">
                <vx-card class="mt-3">
                    <h3>Loading Data.. Please wait..</h3>
                </vx-card>
            </template>
    
            <template v-else>
                <h3 class="text-center" v-if="report">{{ report.name }}</h3>
                <vs-row v-if="date && report_ && package_ && dpr_log_po_data && dpr_log_po_data.sap_po">
                    <vs-col>
                        <vs-table class="freeze_row row2 row3_top_diff" :data="package_keys" noDataText="No Parameters defined for this package">
                            
                            <tr>
                                <vs-th rowspan="2" style="min-width: 50px;">BOQ</vs-th>
                                <vs-th rowspan="2" style="min-width: 190px;">Description of Work</vs-th>
                                <vs-th colspan="5">Median</vs-th>
                                <vs-th rowspan="2" style="min-width: 140px;">Remarks</vs-th>
                                <vs-th colspan="2" style="min-width: 70px;">Images</vs-th>
                                <vs-th rowspan="2" style="min-width: 100px;">Location</vs-th>
                                <vs-th rowspan="2" style="min-width: 70px;">Verified</vs-th>
                                <vs-th rowspan="2" style="min-width: 70px;">Status</vs-th>
                                <vs-th rowspan="2" style="min-width: 55px;"></vs-th>
                                <vs-th rowspan="2" style="min-width: 120px;">Created By</vs-th>
                                <vs-th rowspan="2" style="min-width: 100px;">Closed Status</vs-th>
                                <vs-th rowspan="2" style="min-width: 120px;">Closed On</vs-th>
                                <vs-th rowspan="2" style="min-width: 120px;">Delete Action</vs-th>
                                <vs-th rowspan="2" style="min-width: 80px;">Today's Qty</vs-th>
                            </tr>
                            <tr>
                                <vs-th style="min-width: 50px;">Action</vs-th>
                                <vs-th style="min-width: 100px;">Direction</vs-th>
                                <vs-th style="min-width: 80px;">From</vs-th>
                                <vs-th style="min-width: 80px;">To</vs-th>
                                <vs-th style="min-width: 80px;">Qty</vs-th>
                                <vs-th style="min-width: 80px;">Pre</vs-th>
                                <vs-th style="min-width: 80px;">Post</vs-th>
                            </tr>
    
                            <template v-for="(report_key, index) in package_keys">
                                <template v-for="subindex in data[get_key(report_key.id)].length">
                                    <vs-tr :key="`row-${index}-${subindex}`">
                                        <vs-td :class="{'font-bold': report_key.is_heading}" v-if="subindex == 1" :rowspan="data[get_key(report_key.id)].length">
                                            {{ report_key.boq_no.replace(report_key.parent_key ? `${report_key.parent_key.boq_no}.` : "", "") }}
                                        </vs-td>
                                        <vs-td :class="{'font-bold': report_key.is_heading}" v-if="subindex == 1" :rowspan="data[get_key(report_key.id)].length">
                                            {{ report_key.description }}
                                        </vs-td>
                                        <template v-if="report_key.is_heading">
                                            <vs-td colspan="17"></vs-td>
                                        </template>
                                        <template v-else>
                                            <!-- checkbox  -->
                                            <vs-td>
                                                <template v-if="verifyReviewDPRDaily">
                                                    <vs-checkbox :disabled="!data[get_key(report_key.id)][subindex - 1].id || data[get_key(report_key.id)][subindex - 1].verification_status != 'p'" :vs-value="`${report_key.id}.${subindex - 1}`" v-model="selected_rows" />
                                                </template>
                                                <template v-else-if="reviewDPRDaily">
                                                    <vs-checkbox :disabled="!data[get_key(report_key.id)][subindex - 1].id || !(data[get_key(report_key.id)][subindex - 1].verification_status == 'a' && data[get_key(report_key.id)][subindex - 1].status == 'p')" :vs-value="`${report_key.id}.${subindex - 1}`" v-model="selected_rows" />
                                                </template>
                                                <template v-else>
                                                    -
                                                </template>
                                            </vs-td>
                                            <!-- direction  -->
                                            <vs-td>
                                                <InputSelect
                                                    :model.sync="data[get_key(report_key.id)][subindex - 1].data.median.direction"
                                                    placeholder="Direction"
                                                    :options="direction_options"
                                                    label=""
                                                    :disabled="!hasPermission(report_key.id, subindex - 1)"
                                                    size="small"
                                                    @change="updateValueForRow(report_key.id, subindex - 1)"
                                                />
                                            </vs-td>
                                            <!-- from  -->
                                            <vs-td>
                                                <vs-input @change="updateValueForRow(report_key.id, subindex - 1)" size="small" v-model="data[get_key(report_key.id)][subindex - 1].data.median.from" type="Number" min="0" step="0.3" class="w-full" 
                                                :readonly="!hasPermission(report_key.id, subindex - 1)" />
                                            </vs-td>
                                            <!-- to  -->
                                            <vs-td>
                                                <vs-input @change="updateValueForRow(report_key.id, subindex - 1)" size="small" v-model="data[get_key(report_key.id)][subindex - 1].data.median.to" type="Number" min="0" step="0.3" class="w-full" 
                                                :readonly="!hasPermission(report_key.id, subindex - 1)" />
                                            </vs-td>
                                            <!-- value  -->
                                            <vs-td>
                                                <vs-input size="small" v-model="data[get_key(report_key.id)][subindex - 1].value" type="Number" min="0" step="0.3" class="w-full" :readonly="!hasPermission(report_key.id, subindex - 1)" />
                                            </vs-td>
                                            <!-- remarks  -->
                                            <vs-td>
                                                <vs-input size="small" v-model="data[get_key(report_key.id)][subindex - 1].remarks" class="w-full" 
                                                :readonly="!hasPermission(report_key.id, subindex - 1)" />
                                            </vs-td>
                                            <!-- fileselection pre  -->
                                            <vs-td>
                                                <FileSelection
                                                    :images.sync="data[get_key(report_key.id)][subindex - 1].pre_images"
                                                    :filter="val => val.image_type == undefined || val.image_type == null || val.image_type == 'p'"
                                                    :read_only="!hasPermission(report_key.id, subindex - 1)"
                                                    :embedded_mode="true"
                                                    :multiple="false"
                                                    :can_delete="true"
                                                    @delete_image="data => do_delete_image(data, report_key.id, subindex-1, 'pre')"
                                                />
                                            </vs-td>
                                            <!-- fileselection post  -->
                                            <vs-td>
                                                <FileSelection
                                                    :images.sync="data[get_key(report_key.id)][subindex - 1].post_images"
                                                    :filter="val => val.image_type == undefined || val.image_type == null || val.image_type == 'w'"
                                                    :read_only="!hasPermission(report_key.id, subindex - 1)"
                                                    :embedded_mode="true"
                                                    :can_delete="true"
                                                    :multiple="false"
                                                    @delete_image="data => do_delete_image(data, report_key.id, subindex-1, 'post')"
                                                />
                                            </vs-td>
                                            <!-- map  -->
                                            <vs-td>
                                                <vs-button :key="`button-${index}-${subindex}`" color="primary" type="filled" size="small" @click="$set(data[get_key(report_key.id)][subindex - 1], 'map_popup_active', true)">Map</vs-button>
                                                <vs-popup :active.sync="data[get_key(report_key.id)][subindex - 1].map_popup_active">
                                                    <LocationChooser :disabled="!hasPermission(report_key.id, subindex - 1)" :latitude.sync="data[get_key(report_key.id)][subindex - 1].location_latitude" :longitude.sync="data[get_key(report_key.id)][subindex - 1].location_longitude" :api_errors="{}"/>
                                                </vs-popup>
                                            </vs-td>
                                            <!-- verification status -->
                                            <vs-td>
                                                <template v-if="data[get_key(report_key.id)][subindex - 1].verification_status == 'p'">
                                                    <template>
                                                        <vx-tooltip text= "Pending" color="warning">
                                                            <font-awesome-icon class="text-warning" :icon="pending" />
                                                        </vx-tooltip>
                                                    </template>
                                                </template>
                                                <template v-else-if="data[get_key(report_key.id)][subindex - 1].verification_status == 'a'">
                                                    <template v-if="data[get_key(report_key.id)][subindex - 1].verified_by">
                                                        <vx-tooltip 
                                                            :text="`Approved By: ${data[get_key(report_key.id)][subindex - 1].verified_by.first_name || ''} ${data[get_key(report_key.id)][subindex - 1].verified_by.last_name || ''}`" 
                                                            color="success">
                                                            <font-awesome-icon class="text-success" :icon="approved" />
                                                        </vx-tooltip>
                                                    </template>
                                                    <template v-else>
                                                        <vx-tooltip text="Approved" color="success">
                                                            <font-awesome-icon class="text-success" :icon="approved" />
                                                        </vx-tooltip>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-if="data[get_key(report_key.id)][subindex - 1].verified_by">
                                                        <vx-tooltip 
                                                        :text="`Rejected By: ${data[get_key(report_key.id)][subindex - 1].verified_by.first_name || ''} ${data[get_key(report_key.id)][subindex - 1].verified_by.last_name || ''}`" 
                                                        color="danger">
                                                            <font-awesome-icon class="text-danger" :icon="rejected" />
                                                        </vx-tooltip>
                                                    </template>
                                                    <template v-else>
                                                        <vx-tooltip text="Rejected" color="danger">
                                                            <font-awesome-icon class="text-danger" :icon="rejected" />
                                                        </vx-tooltip>
                                                    </template>
                                                </template>
                                            </vs-td>
                                            <!-- status  -->
                                            <vs-td>
                                                <template v-if="data[get_key(report_key.id)][subindex - 1].status == 'p'">
                                                    <template>
                                                        <vx-tooltip text= "Pending" color="warning">
                                                            <font-awesome-icon class="text-warning" :icon="pending" />
                                                        </vx-tooltip>
                                                    </template>
                                                </template>
                                                <template v-else-if="data[get_key(report_key.id)][subindex - 1].status == 'a'">
                                                    <template v-if="data[get_key(report_key.id)][subindex - 1].reviewed_by">
                                                        <vx-tooltip 
                                                        :text="`Approved By: ${data[get_key(report_key.id)][subindex - 1].reviewed_by.first_name || ''} ${data[get_key(report_key.id)][subindex - 1].reviewed_by.last_name || ''}`" 
                                                        color="success">
                                                            <font-awesome-icon class="text-success" :icon="approved" />
                                                        </vx-tooltip>
                                                    </template>
                                                    <template v-else>
                                                        <vx-tooltip text= "Approved" color="success">
                                                            <font-awesome-icon class="text-success" :icon="approved" />
                                                        </vx-tooltip>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-if="data[get_key(report_key.id)][subindex - 1].reviewed_by">
                                                        <vx-tooltip 
                                                        :text="`Rejected By: ${data[get_key(report_key.id)][subindex - 1].reviewed_by.first_name || ''} ${data[get_key(report_key.id)][subindex - 1].reviewed_by.last_name || ''}`" 
                                                        color="danger">
                                                            <font-awesome-icon class="text-danger" :icon="rejected" />
                                                        </vx-tooltip>
                                                    </template>
                                                    <template v-else>
                                                        <vx-tooltip text= "Rejected" color="danger">
                                                            <font-awesome-icon class="text-danger" :icon="rejected" />
                                                        </vx-tooltip>
                                                    </template>
                                                </template>
                                            </vs-td>
                                            <!-- actions [remove_row, add_empty_row]  -->
                                            <vs-td>
                                                <template v-if="createDPRDaily">
                                                    <vx-tooltip text="Remove Row" color="danger" >
                                                        <vs-button size="small" color="danger" class="p-1 mx-1" @click="remove_row(report_key.id, subindex - 1)" v-if="!data[get_key(report_key.id)][subindex - 1].id && data[get_key(report_key.id)].length >= 2">X</vs-button>
                                                    </vx-tooltip>
                                                    <vx-tooltip text="Add Row" color="primary" >
                                                        <vs-button size="small" class="p-1" @click="add_empty_row(report_key.id)" v-if="subindex == data[get_key(report_key.id)].length">+</vs-button>
                                                    </vx-tooltip>
                                                </template>
                                                <template v-else>
                                                    -
                                                </template>
                                            </vs-td>
                                            <!-- added by  -->
                                            <vs-td>
                                                <template v-if="data[get_key(report_key.id)][subindex - 1].added_by">
                                                    {{ data[get_key(report_key.id)][subindex - 1].added_by.first_name || ''}} {{data[get_key(report_key.id)][subindex - 1].added_by.last_name || '' }}
                                                </template>
                                                <template v-else>
                                                    {{ '' }}
                                                </template>
                                            </vs-td>
                                            <vs-td>
                                                <template v-if="data[get_key(report_key.id)][subindex - 1].closed_status == 'r'">
                                                    <vx-tooltip text="Rejected" color="danger">
                                                        <font-awesome-icon class="text-danger" :icon="rejected" />
                                                    </vx-tooltip>
                                                </template>
                                                <template v-else-if="data[get_key(report_key.id)][subindex - 1].closed_status == 'c'">
                                                    <vx-tooltip text="Completed" color="success">
                                                        <font-awesome-icon class="text-success" :icon="approved" />
                                                    </vx-tooltip>
                                                </template>
                                                <template v-else>
                                                    <vx-tooltip text="Pending" color="warning">
                                                        <font-awesome-icon class="text-warning" :icon="pending" />
                                                    </vx-tooltip>
                                                </template>
                                            </vs-td>
                                            <vs-td>
                                                <template v-if="data[get_key(report_key.id)][subindex - 1].closed_on">
                                                    <FormatText :text="data[get_key(report_key.id)][subindex - 1].closed_on" format="datetime" />
                                                </template>
                                                <template v-else>
                                                    -
                                                </template>
                                            </vs-td>
                                            <!-- delete action  -->
                                            <vs-td>
                                                <template v-if="delete_permission(data[get_key(report_key.id)][subindex - 1])">
                                                    <vx-tooltip text= "Delete" color="danger">
                                                        <vs-button @click="() => {
                                                            delete_popup.id = data[report_key.id][subindex - 1].id
                                                            delete_popup.active = true
                                                        }" size="small" type="flat">
                                                            <font-awesome-icon size="2x" class="text-danger" :icon="deleteIcon"/>
                                                        </vs-button>
                                                    </vx-tooltip>
                                                </template>
                                                <template v-else>
                                                    -
                                                </template>
                                            </vs-td>
                                            <!-- today's qty  -->
                                            <vs-td v-if="subindex == 1" :rowspan="data[get_key(report_key.id)].length">
                                                {{ data[get_key(report_key.id)].reduce((a, v) => a + (parseFloat(v.value) || 0), 0).toFixed(3) }}
                                            </vs-td>
                                        </template>
                                    </vs-tr>
                                </template>
                            </template> 
                        </vs-table>
                    </vs-col>
                </vs-row>
                <vs-row class="mt-3" v-if="date && report_ && package_ && dpr_log_po_data && dpr_log_po_data.sap_po">
                    <vs-col class="text-center">
                        <vs-button v-if="!selected_rows.length && (editDPRDaily || createDPRDaily)" @click="save" class="mx-auto">Save</vs-button>
    
                        <template v-if="verifyReviewDPRDaily && selected_rows.length">
                            <vs-button  @click="verify_approve_all" class="mx-auto mr-3">Verify Approve All</vs-button>
                            <vs-button @click="verify_reject_all" class="mx-auto">Verify Reject All</vs-button>
                        </template>
                        <template v-else-if="reviewDPRDaily && selected_rows.length">
                            <vs-button  @click="approve_all" class="mx-auto mr-3">Approve All</vs-button>
                            <vs-button @click="reject_all" class="mx-auto">Reject All</vs-button>
                        </template>
                    </vs-col>
                </vs-row>
            </template>
    
            <DeletePopup :is_active.sync="delete_popup.active" type="dpr daily entry" @delete_issue="delete_issue" />
        </template>
    </div>
</template>

<script>
import { faPlus, faClock, faCheckCircle, faTimesCircle, faTrash  } from '@fortawesome/free-solid-svg-icons';
import { Request } from '../../utils/requests'
import moment from 'moment';
import FileSelection from '../Issue/Components/FileSelection.vue'
import LocationChooser from '../Issue/Components/LocationChooser.vue';
import DeletePopup from '../components/DeletePopup.vue';

export default {
    components: {
        FileSelection,
        LocationChooser,
        DeletePopup
    },
    props: {
        report_mode: {
            type: Boolean,
            required: false,
        }
    },
    data() {
        return {

            date: this.$route.query.date ? moment(this.$route.query.date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD'),
            is_admin: this.$store.state.auth.userRole == 'admin',
            data: {},
            original_data: {},

            packages: [],

            // package
            report_: this.$route.query.report || null,
            package_: this.$route.query.package || null,
            package_keys: [],

            selected_rows: [],
            api_errors: {},

            loading_modules: {
                packages: false,
                package_keys: false,
                package_data: false,
                dpr_log_po: false
            },

            delete_popup: {
                active: false,
                id: null
            },

            frequency_options: [
                {value: 'day', label: "Day"},
                {value: 'month', label: "Month"},
                {value: 'week', label: "Week"},
                {value: 'year', label: "Year"},
            ],

            direction_options: [
                {value: 'median', label: "Median"},
                {value: 'bhs', label: "BHS"},
                {value: 'rhs', label: "RHS"},
                {value: 'lhs', label: "LHS"},
            ],

            dpr_log_po_data: {
                sap_po: null,
                is_associated: false
            }
        }
    },
    computed: {
        addIcon: () => faPlus,
        pending: () => faClock,
        approved: () => faCheckCircle,
        rejected: () => faTimesCircle,
        deleteIcon: () => faTrash,
        year_options: () => {
            let years = []
            for (let i=new Date().getFullYear(); i>=1990; i--) {
                years.push({value: i, label: i.toString()})
            }

            return years
        },
        package_options() {
            return this.packages.map(v => {
                return {
                    value: v.id,
                    label: v.name
                }
            })
        },
        loading() {
            return Object.keys(this.loading_modules).filter(v => this.loading_modules[v] == true).length > 0
        },
        report_options() {
            return this.$store.state.organisation.dpr_reports.filter(v => v.issue_type == this.$route.params.issue_type).map(
                v => {
                    return {
                        label: v.name,
                        value: v.id
                    }
                }
            )
        },
        report() {
            if (!this.report_) return null
            let matches = this.$store.state.organisation.dpr_reports.filter(v => v.id == this.report_)
            if (matches.length) return matches[0]
            else return null
        },
        viewDPRDaily() {
            return this.hasAccess('read', `dpr_log_daily`, 'all')
        },
        createDPRDaily() {
            return this.hasAccess('create', `dpr_log_daily`, 'all')
        },
        deleteDPRDaily() { 
            return this.hasAccess('delete', `dpr_log_daily`, 'all')
        },
        editDPRDaily() {
            return this.hasAccess('edit', `dpr_log_daily`, 'all')
        },
        verifyReviewDPRDaily() {
            return this.hasAccess('verify_review', `dpr_log_daily`, 'all')
        },
        reviewDPRDaily() {
            return this.hasAccess('review', `dpr_log_daily`, 'all')
        },
    },
    watch: {
        date (newV, oldV) {
            if (newV == oldV) return
            this.load_data()
        },
        package_ (newV, oldV) {
            if (newV == oldV) return
            this.load_data()
        },
        report_ (newV, oldV) {
            if (newV == oldV) return
            this.init()
        },
        "$route.query.report"(newV) {
            this.report_ = newV
        },
        "$route.query.package"(newV) {
            this.package_ = newV
        },
        "$route.query.date"(newV) {
            this.date = newV
        },
    },
    mounted() {
        if (this.report_options.length) {
            if (!this.report_)
                this.report_ = this.report_options[0].value

            if(Object.keys(this.$route.query).length) {
                this.init()
                this.load_data()    
            }
        }
    },
    methods: {
        init() {
            this.load_packages()
        },
        load_packages() {
            if (!this.report_) return
            this.loading_modules.packages = true
            Request(this, 'GET', this.$store.state.apiendpoints.dpr_packages, {report: this.report_, limit: 100}).then(
                res => {
                    this.packages = res.results
                    this.loading_modules.packages = false
                    
                    if ((this.packages.length && !(Object.keys(this.$route.query).length)) || !(this.packages.map(item => item.id).includes(this.package_))) {
                        this.package_ = this.packages[0].id
                    }
                    
                },
                err => {
                    this.loading_modules.packages = false
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred while loading available packages! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        load_data() {
            this.load_dpr_keys()
            this.load_dpr_data()
            this.load_dpr_log_po()
        },
        load_dpr_keys() {
            this.loading_modules.package_keys = true
            let url = `${this.$store.state.apiendpoints.dpr_package_keys}`

            let payload = {
                package: this.package_,
                limit: 100
            }

            Request(this, 'GET', url, payload).then(
                res => {
                    this.loading_modules.package_keys = false
                    this.package_keys = res.results
                },
                err => {
                    this.loading_modules.package_keys = false
                    this.package_keys = []
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred while loading available report parameters! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        load_dpr_data() {
            this.loading_modules.package_data = true

            let url = `${this.$store.state.apiendpoints.dpr_daily}`
            let payload = {
                date: this.date,
                package: this.package_
            }

            Request(this, 'GET', url, payload).then(
                res => {
                    this.loading_modules.package_data = false
                    this.data = res
                    this.original_data = this.deepclone(res)
                },
                err => {
                    this.loading_modules.package_data = false
                    this.data = {}
                }
            )
        },
        load_dpr_log_po() {
            
            this.loading_modules.dpr_log_po = true
            let url = `${this.$store.state.apiendpoints.dpr_log_po}`

            let payload = {
                date: this.date,
                package: this.package_
            }

            Request(this, 'GET', url, payload).then(
                res => {
                    this.loading_modules.dpr_log_po = false
                    this.dpr_log_po_data = res || {
                        sap_po: null,
                        is_associated: false
                    }
                },
                err => {
                    this.loading_modules.dpr_log_po = false
                    this.dpr_log_po_data = {
                        sap_po: null,
                        is_associated: false
                    }
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred while loading Dpr Log PO data! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        is_data_changed(key, sub_key) {
            let new_data = this.data[key][sub_key]
            let old_data = this.original_data[key] ? this.original_data[key][sub_key] : null

            if (!new_data.id && old_data == null) return true

            if(!old_data) return false
            
            // checking for direction 
            if(new_data.data.median.direction != old_data.data.median.direction) return true

            // checking for from 
            if(new_data.data.median.from != old_data.data.median.from) return true

            // checking for to
            if(new_data.data.median.to != old_data.data.median.to) return true

            // checking for value
            if(new_data.value != old_data.value) return true

            // checking for remarks
            if(new_data.remarks != old_data.remarks) return true

            // checking for location latitude
            if(new_data.location_latitude != old_data.location_latitude) return true

            // checking for location longitude
            if(new_data.location_longitude != old_data.location_longitude) return true

            // checking for pre_images - if any new images (without id) have been added
            let new_pre_images = (new_data.pre_images || []).filter(img => !img.id)
            if (new_pre_images.length > 0) return true

            // checking for post_images - if any new images (without id) have been added
            let new_post_images = (new_data.post_images || []).filter(img => !img.id)
            if (new_post_images.length > 0) return true

            return false
        },
        filter_sub_data(key) {
            let res = Object.keys(this.data[key]).filter(sub_key => this.is_data_changed(key, sub_key)).map(sub_key => this.data[key][sub_key])
            if (res.length) {
                return res
            }

            return null
        },
        filter_data() {
            let change_data = {}

            Object.keys(this.data).map(key => {
                let res = this.filter_sub_data(key)
                change_data[key] = res
            })
            
            return change_data
        },
        save() {
            
            this.save_dpr()
            this.save_dpr_log_po()
        },
        save_dpr_log_po() {
            if (!this.dpr_log_po_data || !this.dpr_log_po_data.sap_po) {
                return
            }

            this.$vs.loading()
            let url = `${this.$store.state.apiendpoints.dpr_log_po}`

            Request(this, 'POST', url, null, this.dpr_log_po_data).then(
                res => {
                    this.dpr_log_po_data = res
                    this.$vs.loading.close()
                },
                err => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred while saving Dpr Log PO data! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        save_dpr() {
            this.$vs.loading()

            let filter_data = this.filter_data()
            let report_keys = {}

            Object.keys(filter_data).filter(key => filter_data[key]).map(key => report_keys[key] = filter_data[key])

            let url = `${this.$store.state.apiendpoints.dpr_daily}`

            let payload = {
                date: this.date,
                package: this.package_,
                report_keys: report_keys
            }

            this.api_errors = {}

            Request(this, 'POST', url, null, payload).then(
                async res => {

                    // adding image part from data to res.
                    let keys = Object.keys(res)
                    for(let index=0; index<keys.length; index++) {
                        let data = res[keys[index]]
                        for(let subindex=0; subindex<data.length; subindex++) {
                            data[subindex].pre_images = this.data[keys[index]][subindex].pre_images
                            data[subindex].post_images = this.data[keys[index]][subindex].post_images
                        }
                    }
                    // end

                    this.data = res
                    this.original_data = this.deepclone(res)

                    try {

                        await this.upload_images_for_ids(res)

                        this.submit_disabled = false
                        this.$vs.loading.close()

                        this.$vs.notify({
                            time: 3000,
                            title: 'Saved',
                            text: "Saved Successfully!",
                            iconPack: 'feather',
                            icon: 'icon-check-circle',
                            color: 'success'
                        })

                    } catch (e) {
                        this.submit_disabled = false
                        this.$vs.loading.close()
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "An erorr occurred while uploading images. Please try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                },
                err => {
                    this.$vs.loading.close()
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "Please fix the errors and try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 3000,
                            title: 'Error',
                            text: "An unknown error occurred! Please try again!",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }

                }
            )
        },
        remove_row(key, subindex) {
            this.data[key].splice(subindex, 1)
        },
        add_empty_row(key) {
            this.data[key].push({
                remarks: null,
                value: null,
                status: 'p',
                verification_status: 'p',
                data: {
                    median: {
                        direction: null,
                        from: null,
                        to: null
                    }
                },
                pre_images: [],
                post_images: [],
                location_latitude: null,
                location_longitude: null
            })
        },
        get_key(key) {
            if (!this.data[key]) {
                this.$set(this.data, key, [])
                this.add_empty_row(key)
            }
            
            return key
        },
        updateValueForRow(key, subindex) {

            let row = this.data[key][subindex]

            if(row.data.median.from) row.data.median.from = parseFloat(row.data.median.from).toFixed(3)
            if(row.data.median.to) row.data.median.to = parseFloat(row.data.median.to).toFixed(3)
            
            let new_value = Math.abs((parseFloat(row.data.median.to  || 0)) - (parseFloat(row.data.median.from || 0)))
            
            if (row._value === undefined) {
                // Store original value in the object to utilize later
                row._value = row.value
            }
            
            if (row._value === null || (row._value != null && (row.value == null || row.value == ''))) { 
                row.value = new_value
                // Reset row's original value to allow further changes
                row._value = null
            }

            if(row.value) row.value = parseFloat(row.value).toFixed(3)
            
        },
        approve(row, key) {
            if (row.status != 'p') {
                this.selected_rows.splice(this.selected_rows.findIndex(v => v == key), 1)
                return
            }
            this.$set(row, 'disabled', true)
            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.dpr_log_action, row.id), null, {action: 'approve'}).then(
                res => {
                    this.$set(row, 'status', 'a')
                    this.$set(row, 'disabled', false)
                    this.selected_rows.splice(this.selected_rows.findIndex(v => v == key), 1)
                },
                err => {
                    this.$set(row, 'disabled', false)
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        reject(row, key) {
            if (row.status != 'p') {
                this.selected_rows.splice(this.selected_rows.findIndex(v => v == key), 1)
                return
            }
            this.$set(row, 'disabled', true)
            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.dpr_log_action, row.id), null, {action: 'reject'}).then(
                res => {
                    this.$set(row, 'status', 'r')
                    this.$set(row, 'disabled', false)
                    this.selected_rows.splice(this.selected_rows.findIndex(v => v == key), 1)
                },
                err => {
                    this.$set(row, 'disabled', false)
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        approve_all() {
            this.selected_rows.forEach(key => this.approve(this.data[key.split(".")[0]][key.split(".")[1]], key))
        },
        reject_all() {
            this.selected_rows.forEach(key => this.reject(this.data[key.split(".")[0]][key.split(".")[1]], key))
        },
        verify_approve(row, key) {
            if (row.verification_status != 'p') {
                this.selected_rows.splice(this.selected_rows.findIndex(v => v == key), 1)
                return
            }
            this.$set(row, 'disabled', true)
            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.dpr_log_action, row.id), null, {action: 'verify_approve'}).then(
                res => {
                    this.$set(row, 'verification_status', 'a')
                    this.$set(row, 'disabled', false)
                    this.selected_rows.splice(this.selected_rows.findIndex(v => v == key), 1)
                },
                err => {
                    this.$set(row, 'disabled', false)
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        verify_reject(row, key) {
            if (row.verification_status != 'p') {
                this.selected_rows.splice(this.selected_rows.findIndex(v => v == key), 1)
                return
            }
            this.$set(row, 'disabled', true)
            Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.dpr_log_action, row.id), null, {action: 'verify_reject'}).then(
                res => {
                    this.$set(row, 'verification_status', 'r')
                    this.$set(row, 'disabled', false)
                    this.selected_rows.splice(this.selected_rows.findIndex(v => v == key), 1)
                },
                err => {
                    this.$set(row, 'disabled', false)
                    this.$vs.notify({
                        time: 3000,
                        title: 'Error',
                        text: "An unknown error occurred! Please try again!",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        verify_approve_all() {
            this.selected_rows.forEach(key => this.verify_approve(this.data[key.split(".")[0]][key.split(".")[1]], key))
        },
        verify_reject_all() {
            this.selected_rows.forEach(key => this.verify_reject(this.data[key.split(".")[0]][key.split(".")[1]], key))
        },
        edit_permission(key, subindex) {

            if (!this.data[key][subindex].id || !this.editDPRDaily) return false

            if (this.data[key][subindex].status == 'a') return false

            if(this.data[key][subindex].verification_status == 'a' && this.data[key][subindex].status != 'r') return false

            return true
        },
        hasPermission(key, subindex) {
            return (!this.data[key][subindex].id && this.createDPRDaily) || (this.data[key][subindex].id && this.edit_permission(key, subindex))
        },
        async upload_images_for_ids(data) {
            let keys = Object.keys(data)
            for (let i=0; i < keys.length; i++) {
                await this.upload_images_for_id(data[keys[i]])
            }
        },
        async upload_images_for_id(sub_data) {
            for (let i=0; i < sub_data.length; i++) {
                let images_to_upload = []
                sub_data[i].pre_images.forEach(obj => {
                    this.$set(obj, 'image_type', 'p')
                    if(!obj.id) images_to_upload.push(obj)
                })
                sub_data[i].post_images.forEach(obj => {
                    this.$set(obj, 'image_type', 'w')
                    if(!obj.id) images_to_upload.push(obj)
                })
                await this.upload_images(sub_data[i].id, images_to_upload)
            }
        },
        async upload_images(id, image_data) {
            for (let i=0; i < image_data.length; i++) {
                this.$set(image_data[i], 'status', 'u')
                try {
                    let data = await this.upload_single_image(id, image_data[i])
                    this.$set(image_data[i], 'status', 'c')
                    if (data != null)
                        this.$set(image_data, i, data)
                } catch (e) {
                    this.$set(image_data[i], 'status', 'f')
                    throw e
                }
            }
        },
        async upload_single_image(id, image_obj) {

            return new Promise( (resolve, reject) => {
                if (typeof(image_obj.image) == 'string') resolve(null)

                let payload = new FormData()
                payload.append('image', image_obj.image)
                payload.append('image_type', image_obj.image_type)

                Request(this, 'POST', this.sprintf(this.$store.state.apiendpoints.dpr_log_image, id), null, payload).then(
                    res => resolve(res),
                    err => reject(err)
                )

            })
        },
        do_delete_image(image_data, key, subindex, image_type) {

            this.disabled = true;
            this.$vs.loading();
            let url = this.sprintf(this.$store.state.apiendpoints.dpr_log_image, image_data.dpr_log) + image_data.id + '/'

            Request(this, 'DELETE', url, null, null).then(
                (res) => {
                    if (image_type == 'pre') {
                        this.data[key][subindex].pre_images = this.data[key][subindex].pre_images.filter(obj => !(obj.id == image_data.id))

                    } else if(image_type == 'post') {
                        this.data[key][subindex].post_images = this.data[key][subindex].post_images.filter(obj => !(obj.id == image_data.id))
                    }
                    this.disabled = false
                    this.$vs.loading.close()
                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: 'Image deleted successfully.',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                (err) => {
                    this.disabled = false
                    this.$vs.loading.close()
                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: 'An Error Occured. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        },
        delete_permission(item) {
            if(!item.id || !this.deleteDPRDaily) return false

            const issue_month = (new Date(item.created_on)).getMonth()
            const current_month = (new Date()).getMonth()

            if(issue_month==current_month) return true

            return false
        },
        delete_issue() {

            let url = this.$store.state.apiendpoints.dpr_daily
            this.disabled = true

            let payload = {
                dpr_daily_id: this.delete_popup.id
            }

            Request(this, 'DELETE', url, null, payload).then(
                (res) => {
                    this.delete_popup.active = false
                    this.delete_popup.id = null
                    this.load_dpr_data()
                    this.disabled = false
                    this.$vs.loading.close()
                    this.$vs.notify({
                        time: 2500,
                        title: 'Success',
                        text: 'DPR daily entry deleted successfully.',
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success'
                    })
                },
                (err) => {
                    this.delete_popup.active = false
                    this.delete_popup.id = null
                    this.disabled = false
                    this.$vs.loading.close()

                    this.$vs.notify({
                        time: 2500,
                        title: 'Unknown Error',
                        text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                }
            )
        }
    }
}
</script>

<style lang="scss">
.table-fix {
    .vs-table--tbody {
        padding-bottom: 100px;
        background: #fff;
        border: 0;
    }
}

.vs-table--tbody-table .tr-values:hover {
    transform:none!important;
    -webkit-transform: none!important;
}
</style>